<template>
  <Dialog :header="task" visible :style="{width: '60vw'}" :modal="true" :closable="false">
    <div class="p-fluid p-d-flex">
      <div>
        <label for="type">Avfallstype</label>
        <Listbox v-model="type" id="type" :options="types" optionLabel="name" @input="resetErrors()" />
      </div>
      <div class="p-fluid p-ml-4">
        <div class="p-field">
            <label for="containernumber">Container nummer</label>
            <InputText id="containernumber" type="number" v-model="containernumber" placeholder="eks: 82" />
        </div>
        <div class="p-field">
            <label for="comment">Kommentar</label>
            <Textarea v-model="comment" :autoResize="true" id="comment" rows="5" cols="30" />
        </div>
        <template v-if="type && type.dangerous">
          <Divider />
          <h4>Farlig avfall</h4>
          <div class="p-field" v-if="company.gpcandeclare">
            <label for="comment">Huk av dersom Glør Partner skal deklarere avfallet for deg</label>
            <InputSwitch v-model="gpdeclares" @input="resetErrors()" />
          </div>
          <div v-if="!gpdeclares" class="p-field">
            <label for="comment" class="mandatory">Deklarasjonsnummer</label>
            <InputMask v-model="declarationnumber" placeholder="300.000.659" mask="999.999.999" @input="resetErrors()" />
          </div>
        </template>
        <Message v-for="(error, index) in errors" :key="index" severity="error">{{ error }}</Message>
      </div>
      
    </div>
    
    <template #footer>
        <Button label="Avbryt" icon="pi pi-times" @click="closeModal()" class="p-button-text"/>
        <Button label="Bestill" icon="pi pi-check" @click="makeOrder()" autofocus />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Listbox from 'primevue/listbox';
import Textarea from 'primevue/textarea';
import InputSwitch from 'primevue/inputswitch';
import Divider from 'primevue/divider';
import InputMask from 'primevue/inputmask';
import Message from 'primevue/message';

export default {
name: 'disposalOrder',

components:{
  Dialog,
  Listbox,
  Textarea,
  Divider,
  InputSwitch,
  InputMask,
  Message
},

props: {
  container: {
    type: Object 
  },
  task: {
    type: String
  }
},

data(){
  return{
    type: null,
    containernumber: null, 
    comment: null, 
    declarationnumber: null,
    gpdeclares: false,
    errors: []
  }
},

methods: {
  closeModal(){
    this.$emit('close')
  },
  
  resetErrors(){
    this.errors = []
  },
  
  makeOrder(){
    this.resetErrors()
    if(!this.type)
      this.errors.push('Velg avfallstype')
    if(this.type && this.type.dangerous && (!this.gpdeclares && this.declarationnumber.length != 11))
      this.errors.push('Deklamasjonsnummer mangler eller er ugyldig')
      
    if(this.errors.length)
      return false 
      
    this.$store.dispatch('disposalOrders/add', {
      changeorstop: this.task, 
      comment: this.comment,
      containernumber: this.containernumber,
      companyname: this.company.companyname,
      createdbyadmin: this.isAdmin,
      gpdeclares: this.gpdeclares, 
      containerorderid: this.container.id,
      createddate: new Date(), 
      organizationnumber: this.company.organizationnumber,
      useremail: this.user.Email,
      userid: this.user.id,
      username: this.user.name,
      userphone: (typeof this.user.phone !== 'undefined' ? this.user.phone : '00000000'), 
      wastetype: this.type.name
    })
    .then(() => {
      this.$store.dispatch('containerOrders/update',{
        ...this.container, 
        id: this.container.id,
        wastetype: this.type.name,
        lastUpdated: Date(),
        changeorstop: this.task, 
        comment: null, 
        active: this.task == 'Tømme/Bytte'
      })
      .then(() => {
        this.closeModal()
        this.$toast.add({
          severity:'success',
          summary: `Bestilt`,
          detail: `${this.task} er bestilt`,
          life: 5000,
        })
      })
    })
  }
},

computed:{
  isAdmin(){
    return this.$store.getters['user/isAdmin']
  },
  types(){
    return this.$store.getters["disposalOrders/types"]
  },
  company(){
    return this.$store.getters["companies/current"]
  },
  user(){
    return this.$store.getters["user/get"]
  }
}
}
</script>